import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import moment from "moment";
import Loader from "../../../components/Loader";
import "../../../styles/TransactionHistory.css";

const SlipRow = ({ label, value, valueClass }) => (
  <div className="tx-slip-row">
    <span className="tx-slip-label">{label}</span>
    <span className={`tx-slip-value ${valueClass || ""}`}>{value ?? "—"}</span>
  </div>
);

const TransactionDetailsModal = ({ show, onClose, loading, data }) => {
  const isCredit = data?.txn_type && String(data.txn_type).toUpperCase() === "CREDIT";

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={false} size="md">
      <div className="tx-slip-modal-wrap">
        <div className="tx-slip-header">
          <h5 className="tx-slip-title">Transaction Details</h5>
          <button type="button" className="tx-slip-close" onClick={onClose} aria-label="Close">
            <RiCloseLargeFill size={20} />
          </button>
        </div>

        <Modal.Body className="tx-slip-body p-0">
          {loading ? (
            <Loader message="Loading details..." />
          ) : data ? (
            <div className="tx-slip">
              <div className="tx-slip-brand">Yantra Gaming</div>

              <div className="tx-slip-ref">
                <span className="tx-slip-ref-label">Reference ID</span>
                <span className="tx-slip-ref-value">{data.reference_id ?? "—"}</span>
              </div>

              <div className="tx-slip-divider" />

              <div className="tx-slip-section">
                <div className="tx-slip-section-title">Transaction</div>
                <div className={`tx-slip-amount-block ${isCredit ? "credit" : "debit"}`}>
                  <span className="tx-slip-amount-label">{isCredit ? "Credit" : "Debit"}</span>
                  <span className="tx-slip-amount-value">
                    {data.amount != null ? `₹${Number(data.amount).toFixed(2)}` : "—"}
                  </span>
                </div>
                <SlipRow label="Type" value={data.txn_type} />
                <SlipRow label="Reference Type" value={data.reference_type} />
                <SlipRow label="Remark" value={data.remark} />
              </div>

              <div className="tx-slip-divider" />

              <div className="tx-slip-section">
                <div className="tx-slip-section-title">Balance</div>
                <SlipRow
                  label="Before"
                  value={data.balance_before != null ? `₹${Number(data.balance_before).toFixed(2)}` : "—"}
                />
                <SlipRow
                  label="After"
                  value={data.balance_after != null ? `₹${Number(data.balance_after).toFixed(2)}` : "—"}
                />
              </div>

              <div className="tx-slip-divider" />

              <div className="tx-slip-section">
                <div className="tx-slip-section-title">User</div>
                <SlipRow label="Name" value={data.user_name} />                
                <SlipRow label="Mobile" value={data.user_mobile} />               
              </div>

              <div className="tx-slip-divider" />

              <div className="tx-slip-section">
                <div className="tx-slip-section-title">Created</div>
                <SlipRow
                  label="By"
                  value={data.created_by_name ? `${data.created_by_name} (${data.created_by_username ?? ""})` : "—"}
                />
                <SlipRow
                  label="At"
                  value={data.created_at ? moment.utc(data.created_at).format("DD/MM/YYYY hh:mm A") : "—"}
                />
                <SlipRow label="IP" value={data.ip_address} />
                {data.device_id ? <SlipRow label="Device ID" value={data.device_id} /> : null}
              </div>

              <div className="tx-slip-footer"></div>
            </div>
          ) : (
            <div className="tx-slip-empty">No data</div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default TransactionDetailsModal;
